module.exports = __webpack_public_path__ + "static/m_solution6-508c097802a179eeb6bee4b8c3237a98.png";